{
  "colorSwatchPicker": "Échantillons de couleurs",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Sélectionner un élément",
  "tableResizer": "Redimensionneur"
}
